"use client";

import React, { useEffect, useState } from "react";
import Modal from "../common/Modal";
import ProductShowcase from "./ProductShowcase";
import { ProductDetail, Product } from "@/packages/types/products";
import { fetchProductDetailBySlug } from "@/api-service/product";
import { toast } from "sonner";

interface QuickViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  slug?: string;
  product?: Product | ProductDetail;
  onAddedToCart?: (product: Product) => void;
}

const QuickViewModal: React.FC<QuickViewModalProps> = ({
  isOpen,
  onClose,
  slug,
  product: initialProduct,
  onAddedToCart,
}) => {
  const [product, setProduct] = useState<ProductDetail | undefined>();

  useEffect(() => {
    const targetSlug = slug || initialProduct?.slug;
    if (!targetSlug) return;
    const fetchData = async () => {
      try {
        const products = await fetchProductDetailBySlug(targetSlug);
        setProduct(products.data);
      } catch (error: unknown) {
        console.error("Error fetching products:", error);
        type ApiErr = { data?: { data?: { message?: string } } };
        const msg =
          (error as ApiErr).data?.data?.message ||
          (error instanceof Error ? error.message : "Something went wrong");
        toast.error(msg);
      }
    };
    fetchData();
  }, [slug, initialProduct]);


  const handleAddedToCart = (prod: Product) => {
    if (onAddedToCart) onAddedToCart(prod);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      {slug && product ? (
        <ProductShowcase
          product={product}
          onAddedToCart={handleAddedToCart}
          autoplay={false}
        />
      ) : (
        <div className="p-6 text-center">Loading...</div>
      )}
    </Modal>
  );
};

export default QuickViewModal;
